import apiClient from "utils/apiClient";


export const AUDIT_ACTION_TYPES = [
  { value: "WEBSITE_CREATED", label: "Website created", icon: "circle-plus", tone: "neutral" },
  { value: "CONTENT_UPDATED", label: "Content updated", icon: "edit", tone: "neutral" },
  { value: "GENERATION_TRIGGERED", label: "Generation triggered", icon: "player-play", tone: "neutral" },
  { value: "GENERATION_RETRIED", label: "Generation retried", icon: "refresh", tone: "neutral" },
  { value: "REGENERATED_FROM_BLUEPRINT", label: "Reset to blueprint", icon: "rotate", tone: "warning" },
  { value: "PUBLISHED", label: "Published", icon: "world", tone: "positive" },
  { value: "NEWSLETTER_CAMPAIGN_CREATED", label: "Campaign created", icon: "mail", tone: "neutral" },
  { value: "NEWSLETTER_CAMPAIGN_UPDATED", label: "Campaign updated", icon: "edit", tone: "neutral" },
  { value: "NEWSLETTER_CAMPAIGN_SENT", label: "Campaign sent", icon: "send", tone: "positive" },
  { value: "NEWSLETTER_CAMPAIGN_DELETED", label: "Campaign deleted", icon: "trash", tone: "warning" },
  { value: "DOMAIN_PAYMENT_CHARGED", label: "Payment charged", icon: "credit-card", tone: "positive" },
  { value: "DOMAIN_PAYMENT_AUTHORIZED", label: "Payment authorized", icon: "credit-card", tone: "neutral" },
  { value: "DOMAIN_PAYMENT_RELEASED", label: "Payment released", icon: "credit-card", tone: "neutral" },
  { value: "DOMAIN_PAYMENT_FAILED", label: "Payment failed", icon: "alert-triangle", tone: "negative" },
];

export const AUDIT_ENTITY_TYPES = [
  { value: "WEBSITE", label: "Website" },
  { value: "DOMAIN_ORDER", label: "Domain order" },
];

const ACTION_MAP = Object.fromEntries(AUDIT_ACTION_TYPES.map((a) => [a.value, a]));

function cleanParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  );
}

function enrich(entry) {
  const meta = ACTION_MAP[entry.action];
  return {
    ...entry,
    label: meta?.label ?? entry.action,
    icon: meta?.icon ?? "list-details",
    tone: meta?.tone ?? "neutral",
  };
}

export async function fetchAuditLogs({ query = "", entityType = "", action = "", actorId = "", page = 0, size = 50 } = {}) {
  const { data } = await apiClient.get("/ovizia-service/api/v1/admin/audit-logs", {
    params: cleanParams({ query, entityType, action, actorId, page, size }),
  });
  return data.content.map(enrich);
}

export async function fetchWebsiteAuditHistory(websiteId, { page = 0, size = 50 } = {}) {
  const { data } = await apiClient.get(`/ovizia-service/api/v1/admin/audit-logs/website/${websiteId}`, {
    params: cleanParams({ page, size }),
  });
  return data.content.map(enrich);
}